/* tslint:disable */
/* eslint-disable */
export enum LogEventType {
  ProjectCreated = 'projectCreated',
  ProjectEdited = 'projectEdited',
  ProjectDeleted = 'projectDeleted',
  WorkPackageCreated = 'workPackageCreated',
  WorkPackageEdited = 'workPackageEdited',
  WorkPackageDeleted = 'workPackageDeleted',
  AttachmentCreated = 'attachmentCreated',
  AttachmentEdited = 'attachmentEdited',
  AttachmentDeleted = 'attachmentDeleted'
}
